import { ConfirmationParams, SortOrder } from '@approvalmax/ui/src/components';

import { SortingDirection } from '../../XeroAirwallexBatchPaymentForm.types';
import { messages } from './XeroAirwallexBatchPaymentFormContent.messages';

export const popupTargetElementId = 'requestCardWrapper';

export const tableSortOrderToSortingDirectionMap = {
    [SortOrder.asc]: SortingDirection.Ascending,
    [SortOrder.desc]: SortingDirection.Descending,
};

export const confirmationPopupProps: ConfirmationParams = {
    size: 'small',
    cancelButtonColor: 'blue80',
    confirmButtonColor: 'red40',
    confirmTitle: messages.confirmationPopupTitle,
    confirmMessage: messages.confirmationPopupDescription,
    cancelButtonMessage: messages.cancelButtonText,
    confirmButtonMessage: messages.confirmButtonText,
};
